import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_TEMPLATES,
    GET_SINGLE_TEMPLATE,
} from './templateTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_ALL_TEMPLATES:
            return {
                ...state,
                all_templates: action.payload,
            }
        case GET_SINGLE_TEMPLATE:
            return {
                ...state,
                single_template: action.payload,
            }
        default:
            return state
    }
}
